import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const Notice = () => {
  useEffect(() => {
    if (window.jQuery) {
      const $ = window.jQuery;
      if ($.fn.tab) {
        $(".tab1").tab();
        $(".tab2").tab({ trigger_event_type: "mouseover" });
      }
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-content">
      <SEO
        title="Official Notices & Announcements"
        description="Stay updated with the latest official notices from Gateway Financial. Information on upfront margin, Smart ODR, and important guidelines for option dealing clients."
      />
      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{
                backgroundImage: "url('/images/other-banner.png')",
              }}
            >
              <canvas id="canvas"></canvas>
              <div className="carousel-caption">
                <h1>Notice</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <h5>
                a. Notice on Collection of Upfront Margin from 1 Aug, 2020 in
                Cash Segment:
              </h5>
              <ul className="listitem">
                <li>
                  It is to inform you that SEBI Vide circular dated August 01,
                  2019; February 25, 2020 has made Margin collection (Initial
                  Margin; M2M) mandatory for trading in Cash/Equity Segment
                  effective August 01, 2020 failing which Penalty will be levied
                  by the Exchanges for not meeting the Margin requirement.
                </li>
                <li>
                  Therefore, in compliance with the same, we request all the
                  clients to provide us the sufficient margin either in the form
                  of Funds and or securities before undertaking any trade on the
                  Exchange through us. Moreover, it is also applicable for
                  intraday trades undertaken by the client.
                </li>
                <li>
                  We request you to provide the securities in our client
                  Collateral account if you wish to undertake the trade and
                  comply with the SEBI requirement of fulfilling the Margin
                  obligation requirement in Cash Segment (Applicable on both
                  Delivery; Non-Delivery).
                </li>
                <li>
                  It is also reiterated that SEBI circular also envisages that
                  the Shares can be given for Margin to the Stock broker through
                  Pledge Instruction only initiated through depository System.
                </li>
                <li>
                  Therefore in lieu of the same any charges levied by the
                  Depository will be simultaneously charged to clients on actual
                  basis.
                </li>
                <li>
                  Therefore, we request you to kindly Provide us the Margin as
                  required through SEBI circular as mentioned above in order to
                  meet the margin requirement as applicable for trading in the
                  Cash segment.
                </li>
              </ul>

              <h5 className="mt-5">
                b. Investor Awareness Notice w.r.t Smart ODR:
              </h5>
              <h5>
                <i className="fa fa-check" aria-hidden="true"></i> What is SMART
                ODR?
              </h5>
              <p>
                The SMART ODR (Online Dispute Resolution Portal) is an
                investor-friendly, fully digital platform introduced by SEBI to
                resolve disputes between investors and market intermediaries in
                a fast, cost-effective, and transparent manner. This platform
                enables online conciliation and arbitration, making the dispute
                resolution process seamless and accessible from anywhere.
              </p>

              <h5>
                <i className="fa fa-check" aria-hidden="true"></i> Key
                Highlights:
              </h5>
              <ul className="listitem">
                <li>100% Online – No paperwork or physical visits.</li>
                <li>Quick and Transparent – Time-bound resolution process.</li>
                <li>For All Investors – Retail and institutional clients.</li>
                <li>
                  Covers Brokers, Depository Participants, AMCs, RTAs, etc.
                </li>
              </ul>

              <h5>
                <i className="fa fa-check" aria-hidden="true"></i> How to Use
                the SMART ODR Platform?
              </h5>
              <ul className="listitem">
                <li>
                  First, raise your complaint directly with us (the market
                  participant).
                </li>
                <li>
                  If not resolved satisfactorily, escalate via SEBI SCORES
                  (https://scores.gov.in).
                </li>
                <li>
                  If still unresolved, initiate dispute resolution via the SMART
                  ODR Portal:
                </li>
                <li>Visit: https://smartodr.in</li>
                <li>Register/login</li>
                <li>Submit your complaint and documents</li>
                <li>Track resolution status online</li>
              </ul>

              <h5>
                <i className="fa fa-check" aria-hidden="true"></i> Who Can Use
                SMART ODR?
              </h5>
              <ul className="listitem">
                <li>Investors (retail and institutional)</li>
                <li>Clients of stock brokers, DPs, AMCs, RTAs, etc.</li>
                <li>
                  Any party involved in securities market-related disputes
                </li>
              </ul>

              <h5>
                <i className="fa fa-check" aria-hidden="true"></i> Why It
                Matters:
              </h5>
              <ul className="listitem">
                <li>
                  This initiative by SEBI enhances investor protection and
                  provides an efficient grievance redressal mechanism for
                  disputes involving market entities.
                </li>
                <li>
                  As a responsible market participant, we encourage all our
                  clients to utilize the SMART ODR platform for resolution of
                  unresolved issues.
                </li>
              </ul>

              <h5>Issued in public interest</h5>
              <h5 className="mb-3">
                As per SEBI Circular SEBI/HO/OIAE/OIAE_IAD-1/P/CIR/2023/145
              </h5>

              <h5 className="mt-5">
                c. Notice for Option Dealing Clients/Investors
              </h5>
              <p>
                <b>Dear Clients,</b>
              </p>
              <p>
                NSE Vide its circular dated July 06, 2022 has informed the
                trading members to carry out due diligence of all those clients
                wishing to trade in derivative segment of the Exchange more
                specifically in the Options segment to avoid any kind
                risk/threat that may occur as the derivative Products are not
                designed for general Public whose Income does not support the
                trade Position in Options.
              </p>
              <p>
                Further in line with this circular all clients trading in
                derivative segments are informed to kindly update your financial
                details/income with us so as to avoid disallowance of trading in
                derivative Products.
              </p>
              <p>
                Our compliance department will analyse the Income details with
                the turnover and in case of any serious deviation your account
                will be blocked for trading in derivative Products and it will
                be at the sole discretion of Gateway Financial Services Limited.
              </p>
              <p>
                Further Please also note that following actions needs your
                attention at all times and request you to desist from following
                activity to ensure smooth Operations of your trading account
                maintained with us.
              </p>
              <ul className="listitem">
                <li>
                  Sharing of trading credentials – login id &amp; passwords
                  including OTPs.
                </li>
                <li>
                  Trading in leveraged products like options without proper
                  understanding, which could lead to losses
                </li>
                <li>
                  Writing/ selling options or trading in option strategies based
                  on tips, without basic knowledge &amp; understanding of the
                  product and its risks
                </li>
                <li>
                  Dealing in unsolicited tips through WhatsApp, Telegram,
                  YouTube, Facebook, SMS, calls, etc.
                </li>
                <li>
                  Trading in “Options” based on recommendations from
                  unauthorised / unregistered investment advisors and
                  influencers.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href="#download" className="lm-btn">
                download &amp; explore more
              </a>
            </div>
            <div className="col-lg-6">
              <img src="/images/app-pic.jpg" className="img-fluid" alt="App" />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default Notice;
